// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".chart-customization-panel__wWWdt9dp .section__E67YzNsQ{border:0;border-bottom:1px solid var(--gray2);padding:8px 12px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"chartCustomizationPanel": "chart-customization-panel__wWWdt9dp",
	"section": "section__E67YzNsQ"
};

/*** EXPORTS FROM exports-loader ***/
export default ___CSS_LOADER_EXPORT___.toString();
